module.exports = __webpack_public_path__ + "static/media/descargar-apple-app.5fbab2d2.svg";